// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';

/**
 * A container query driven responsive layout for "Settings" tabs on server interior pages
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
const SettingsLayoutContainer = ({ children }) => {
	return (
		<Box
			sx={{
				containerName: 'settings-tab',
				containerType: 'inline-size',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					gap: {
						'@0/settings-tab': 300,
						'@648/settings-tab': 600,
					},
					flexDirection: {
						'@0/settings-tab': 'column',
						'@648/settings-tab': 'row',
					},
					marginTop: {
						// we want visually less space between the header and
						// content for the Settings tab on small screens
						'@0/settings-tab': -300,
						'@648/settings-tab': 0,
					},
				}}
			>
				{children}
			</Box>
		</Box>
	);
};

export default SettingsLayoutContainer;
